import { Box } from '@mui/material'

import { EditISFPTab, type EditISFPTabToggleProps } from './EditISFPTabToggle.types'

const EditISFPTabToggle = ({ selectedTab, onTabChange }: EditISFPTabToggleProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        position: 'relative',
        borderRadius: '12px',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          border: '2px solid #F5F5F7',
          borderRadius: '12px',
          pointerEvents: 'none',
          zIndex: 0,
        },
      }}
    >
      <Box
        onClick={() => onTabChange(EditISFPTab.ISFPData)}
        sx={{
          flex: 1,
          padding: '12px 16px',
          textAlign: 'center',
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: '20px',
          letterSpacing: '0.1px',
          backgroundColor: selectedTab === EditISFPTab.ISFPData ? '#181D29' : 'transparent',
          color: selectedTab === EditISFPTab.ISFPData ? '#ffffff' : undefined,
          borderRadius: '12px',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          position: 'relative',
          zIndex: 1,
        }}
      >
        ISFP-Daten
      </Box>
      <Box
        onClick={() => onTabChange(EditISFPTab.CostsAndPrices)}
        sx={{
          flex: 1,
          padding: '12px 16px',
          textAlign: 'center',
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: '20px',
          letterSpacing: '0.1px',
          backgroundColor: selectedTab === EditISFPTab.CostsAndPrices ? '#181D29' : 'transparent',
          color: selectedTab === EditISFPTab.CostsAndPrices ? '#ffffff' : undefined,
          borderRadius: '12px',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          position: 'relative',
          zIndex: 1,
        }}
      >
        Kosten & Preise
      </Box>
      <Box
        onClick={() => onTabChange(EditISFPTab.Funding)}
        sx={{
          flex: 1,
          padding: '12px 16px',
          textAlign: 'center',
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: '20px',
          letterSpacing: '0.1px',
          backgroundColor: selectedTab === EditISFPTab.Funding ? '#181D29' : 'transparent',
          color: selectedTab === EditISFPTab.Funding ? '#ffffff' : undefined,
          borderRadius: '12px',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          position: 'relative',
          zIndex: 1,
        }}
      >
        Förderung
      </Box>
    </Box>
  )
}

export default EditISFPTabToggle
